import { Reveal } from "../components/Motion";
import { doctor } from "../lib/data";
import { Phone, Mail, MapPin, Send, ExternalLink } from "lucide-react";

const MAPS_EMBED =
  "https://www.google.com/maps?q=" +
  encodeURIComponent("проспект Соборності 17 корпус 2, Київ") +
  "&hl=uk&z=16&output=embed";

export default function Contacts() {
  return (
    <div data-testid="page-contacts">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Контакти</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Звʼяжіться зі мною
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Найшвидший спосіб отримати відповідь — Telegram. Для запису скористайтеся
              формою онлайн-запису.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-luxe grid md:grid-cols-2 gap-8 lg:gap-12">
          <Reveal>
            <div className="rounded-3xl border border-line p-8 md:p-12 bg-bone space-y-6">
              <h2 className="font-serif text-3xl md:text-4xl tracking-tight">Прямі контакти</h2>

              <div className="flex items-start gap-4 pt-4">
                <Phone size={20} strokeWidth={1.3} className="text-warmGray mt-1 shrink-0" />
                <div>
                  <div className="overline text-warmGray mb-1">Телефон</div>
                  {doctor.phones.map((p, i) => (
                    <a
                      key={p}
                      data-testid={`contact-phone-${i}`}
                      href={`tel:${doctor.phonesRaw[i]}`}
                      className="block text-lg hover:text-warmGray transition"
                    >
                      {p}
                    </a>
                  ))}
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Send size={20} strokeWidth={1.3} className="text-warmGray mt-1 shrink-0" />
                <div>
                  <div className="overline text-warmGray mb-1">Telegram</div>
                  <a
                    data-testid="contact-telegram"
                    href={doctor.telegram}
                    target="_blank"
                    rel="noreferrer"
                    className="text-lg hover:text-warmGray transition"
                  >
                    {doctor.telegramHandle}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail size={20} strokeWidth={1.3} className="text-warmGray mt-1 shrink-0" />
                <div>
                  <div className="overline text-warmGray mb-1">Email</div>
                  <a
                    data-testid="contact-email"
                    href={`mailto:${doctor.email}`}
                    className="text-lg break-all hover:text-warmGray transition"
                  >
                    {doctor.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <MapPin size={20} strokeWidth={1.3} className="text-warmGray mt-1 shrink-0" />
                <div>
                  <div className="overline text-warmGray mb-1">Адреса</div>
                  <div data-testid="contact-address" className="text-base md:text-lg leading-relaxed max-w-sm">
                    {doctor.address}
                  </div>
                  <a
                    data-testid="contact-maps-link"
                    href={doctor.mapsLink}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3 inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase border-b border-ink pb-0.5 hover:gap-3 transition-all"
                  >
                    Прокласти маршрут <ExternalLink size={12} strokeWidth={1.5} />
                  </a>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal>
            <div
              data-testid="contact-map"
              className="rounded-3xl overflow-hidden h-full min-h-[480px] border border-line bg-sand relative"
            >
              <iframe
                title="Tetiana Zolotko Clinic — Google Maps"
                src={MAPS_EMBED}
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: 480, filter: "grayscale(0.15) contrast(0.95)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              <a
                data-testid="contact-map-overlay-link"
                href={doctor.mapsLink}
                target="_blank"
                rel="noreferrer"
                className="absolute bottom-5 left-5 inline-flex items-center gap-2 rounded-full bg-ink/95 text-bone px-5 py-3 text-[10px] tracking-[0.28em] uppercase backdrop-blur hover:bg-black transition"
              >
                <MapPin size={12} strokeWidth={1.5} /> Відкрити в Google Maps
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
